var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-list',{ref:"paymentHistory",attrs:{"id":"subscriptionPaymentHistory","color":"primary","items":_vm.invoices,"placeholder":_vm.paymentHistoryPlaceholder,"tile":_vm.paymentHistoryTile()}})}
var staticRenderFns = []

export { render, staticRenderFns }